import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { NewShipmentService } from '../../shared/services/new-shipment.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectRole } from '../../../store/profile/profile.state';
import { RoleEnum } from '../../../enum/role.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatFabButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-create-shipment-button',
    templateUrl: './create-shipment-button.component.html',
    styleUrls: ['./create-shipment-button.component.scss'],
    imports: [MatFabButton, IconComponent, AsyncPipe]
})
export class CreateShipmentButtonComponent implements OnInit {

    busy$: Observable<boolean>;
    busy: Subject<boolean>;

    constructor(private router: Router, private shipments: NewShipmentService,
                private snackbar: MatSnackBar, private store: Store<AppState>) {
    }

    createShipments$ = this.store.select(selectRole(RoleEnum.CREATE_SHIPMENTS));

    ngOnInit(): void {
        this.busy = new BehaviorSubject(false);
        this.busy$ = this.busy.asObservable();
    }

    createShipment(): void {
        this.busy.next(true);
        this.shipments.create().subscribe((shipment) => {
            this.busy.next(false);
            this.router.navigate([ 'shipment', shipment.id ]).then();
        }, () => {
            this.busy.next(false);
            this.snackbar.open($localize`Unable to create a new shipment`);
        });
    }

}
